import { render, staticRenderFns } from "./Chem241LutherSpectralProblem1.vue?vue&type=template&id=5dbb680c&scoped=true&"
import script from "./Chem241LutherSpectralProblem1.vue?vue&type=script&lang=js&"
export * from "./Chem241LutherSpectralProblem1.vue?vue&type=script&lang=js&"
import style0 from "./Chem241LutherSpectralProblem1.vue?vue&type=style&index=0&id=5dbb680c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb680c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VFileInput,VForm,VRadio,VRadioGroup})
